import ReactMarkdown from 'react-markdown';
import { BlockMath, InlineMath } from 'react-katex';
import remarkMath from 'remark-math'
import rehypeKatex from 'rehype-katex'
import rehypeExternalLinks from 'rehype-external-links'
import 'katex/dist/katex.min.css';

const _mapProps = (props) => ({
  ...props,
  remarkPlugins: [ remarkMath ],
  rehypePlugins: [ rehypeKatex, [rehypeExternalLinks, {target: '_blank'}] ],
  components: {
    ...props.components,
    math: ({ value }) => <BlockMath>{value}</BlockMath>,
    inlineMath: ({ value }) => <InlineMath>{value}</InlineMath>
  }
});

const Markdown = (props) => <ReactMarkdown {..._mapProps(props)} />;

export default Markdown;
